import { ButtonBase, ListItem, Typography } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import type { MouseEvent } from 'react';
import { useNavigateToMissingField } from '@/common/hooks/useNavigateToMissingField';

interface Props {
  name: string;
  label: string;
  cardButtonId?: string;
  formPath?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}
export const MissingRequiredFieldLink = ({
  name,
  label,
  cardButtonId,
  formPath,
  onClick,
}: Props) => {
  const isMobile = useIsMobile();
  const { handleNavigateToField } = useNavigateToMissingField({
    label,
    cardButtonId,
    fieldName: name,
    isMobile,
    formPath,
  });

  if (!label || !name) {
    return null;
  }

  return (
    <ListItem disablePadding key={name} sx={{ py: 0.5 }}>
      <ButtonBase
        disableRipple
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }
          e.stopPropagation();
          void handleNavigateToField();
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'primary.main',
            '&:hover': {
              color: 'primary.dark',
            },
          }}
        >
          {label}
        </Typography>
      </ButtonBase>
    </ListItem>
  );
};
